import dropDownImage from "../DateFilterImages/DropdownImage/DropDownImg.svg"
import CropDropDownImage from './CropdropdownImg.svg';
import DateWrapperImage from "./DateAndTimeImg.svg"
import DateIcon from './DateIcon.svg';

export const dropDownImgIcon = dropDownImage;
export const CropDropDownImgIcon = CropDropDownImage;
export const DateandTimeImgIcon = DateWrapperImage;
export const DateIconImg = DateIcon;